/**
 * Polyfills for Node.js environment in the browser
 * This helps libraries that were designed for Node.js work in the browser
 */

export const setupNodePolyfills = () => {
  // Don't run this multiple times
  if (window.__nodePolyfillsInitialized) return;

  // Process object
  if (typeof window.process === "undefined") {
    window.process = {};
  }

  // Process.env
  window.process.env = window.process.env || {};
  window.process.env.NODE_ENV = window.process.env.NODE_ENV || "production";

  // Process stdout/stderr (for chalk/colors)
  window.process.stdout = window.process.stdout || {
    isTTY: false,
    write: () => {},
  };
  window.process.stderr = window.process.stderr || {
    isTTY: false,
    write: () => {},
  };

  // Process versions
  window.process.version = "v16.0.0"; // Fake version
  window.process.versions = { node: "16.0.0" };

  // Process platform
  window.process.platform = "browser";

  // Process event emitter methods
  window.process.on =
    window.process.on ||
    function () {
      return window.process;
    };
  window.process.addListener =
    window.process.addListener ||
    function () {
      return window.process;
    };
  window.process.once =
    window.process.once ||
    function () {
      return window.process;
    };
  window.process.off =
    window.process.off ||
    function () {
      return window.process;
    };
  window.process.removeListener =
    window.process.removeListener ||
    function () {
      return window.process;
    };
  window.process.removeAllListeners =
    window.process.removeAllListeners ||
    function () {
      return window.process;
    };
  window.process.emit =
    window.process.emit ||
    function () {
      return false;
    };

  // Process nextTick (important for many async operations)
  window.process.nextTick =
    window.process.nextTick ||
    function (cb) {
      setTimeout(cb, 0);
    };

  // Buffer
  if (typeof window.Buffer === "undefined") {
    // Simple Buffer polyfill
    window.Buffer = {
      from: (data, encoding) => {
        if (typeof data === "string") {
          // Simple encoding for common cases
          if (encoding === "base64") {
            return {
              toString: () => atob(data),
              length: atob(data).length,
            };
          }
          return {
            toString: () => data,
            length: data.length,
          };
        }
        return data;
      },
      isBuffer: () => false,
      concat: (list) => list[0],
    };
    window.Buffer.Buffer = window.Buffer;
  }

  // Global object
  if (typeof window.global === "undefined") {
    window.global = window;
  }

  // Mark as initialized
  window.__nodePolyfillsInitialized = true;

  console.log("Node.js polyfills initialized for browser environment");
};

// Run the setup immediately if this file is imported
setupNodePolyfills();

export default setupNodePolyfills;
